import template from './share-amount-rent.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.shareAmountRent', [])
    .directive('cianAfAboutObjectShareAmountRent', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.validation = validation(this.form, 'shareAmountRent', {
                parse: 'Введите одно из значений по примеру: 25%, 0.25 или 1/4',
                required: 'Введите значение',
                max: 'Доля должна быть меньше 1(100%)',
                min: 'Значение не может быть меньше или равно 0',
            });
        }],
        controllerAs: 'shareAmountRent',
        template,
    }))
    .name;
